import React, {Component} from 'react';
import {Grid, Row, Col, ControlLabel, FormControl, InputGroup, Checkbox} from "react-bootstrap";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import Links from "../../../../utilities/linksConfig/Links";
import JednorazoweTable from "./components/JednorazoweTable";
import BiletyService from "../biletyApi/BiletyService";
import DateAndTimeUtilities from "../../../../utilities/DateAndTimeFormat";
import moment from "moment/moment";
import SzukajJednorazowychForm from "./components/SzukajJednorazowychForm";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import ReactNotify from 'react-notify';
import LSService from "../../../../utilities/localStorageService/LSService";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import BiletKodZParagonuContainer from "./components/bilety_kod_z_paragonu_components/BiletKodZParagonuContainer";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import ReactTooltip from "react-tooltip";

export default class BiletyJednorazoweContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bilety: [],
            trasy: [],
            params: {
                dataOd: moment(),
                dataDo: moment(),
                trasa: null,
                godz: null,
                czyDataSprzedazy: false
            },
            paramsObsady: null,
            numerZParagonu: '',
            biletZSzukaniaPoKodzieZParagonu: null,
            pokazModal: false,
            setLoader: false,
            errorModal: '',
            szukaneIdKursu: null,
            ukryjAnulowane: true,

        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeGodzina = this.onChangeGodzina.bind(this)
        this.onChangeIlosc = this.onChangeIlosc.bind(this)
        this.ustawParametryWyszukiwaniaZObsady = this.ustawParametryWyszukiwaniaZObsady.bind(this)
        this.ustawParametryWyszukiwaniaZRozliczeniaKierowcow = this.ustawParametryWyszukiwaniaZRozliczeniaKierowcow.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()

        if (Boolean(LSService.pobierzWyszukiwanieBiletowZObsad())) {
            this.ustawParametryWyszukiwaniaZObsady(LSService.pobierzWyszukiwanieBiletowZObsad())
        }
        else if (Boolean(LSService.pobierzWyszukiwanieBiletowZRozliczeniaKierowcow())) {
            this.ustawParametryWyszukiwaniaZRozliczeniaKierowcow(LSService.pobierzWyszukiwanieBiletowZRozliczeniaKierowcow())
        } else {
            this.pobierzBilety(this.state.params, this.state.ukryjAnulowane)
            this.setState({paramsObsady: null})
        }
    }

    ustawParametryWyszukiwaniaZRozliczeniaKierowcow(params) {

        this.setState({szukaneIdKursu: params.idKu.toString()})
        let paramsSzukaj = {
            dataOd: moment(params.data),
            dataDo: moment(params.data),
            trasa: null,
            godz: null,
            czyDataSprzedazy: false
        }

        this.pobierzBilety(paramsSzukaj, this.state.ukryjAnulowane)

        this.refs.notificator.success('Wczytano bilety na kurs ' + params.idKu.toString() + " z dnia " + params.data, "", 3000)

        LSService.usunWyszukiwanieBiletowZORozliczeniaKierowcow()
    }

    ustawParametryWyszukiwaniaZObsady(params) {
        /*this.setState({paramsObsady: params})
        let paramsSzukaj = {
            dataOd: moment(params.data),
            dataDo: moment(params.data),
            trasa: params.idTr,
            godz: params.godz.toString(),
        }
        this.pobierzBilety(paramsSzukaj,this.state.ukryjAnulowane)*/

        console.log(params)

        this.setState({szukaneIdKursu: params.idKu.toString()})
        let paramsSzukaj = {
            dataOd: moment(params.data),
            dataDo: moment(params.data),
            trasa: null,
            godz: null,
            czyDataSprzedazy: false
        }

        this.pobierzBilety(paramsSzukaj, true)

        this.refs.notificator.success('Wczytano bilety na kurs ' + params.idKu.toString() + " z dnia " + params.data, "", 3000)

        LSService.usunWyszukiwanieBiletowZObsad()
    }

    pobierzBilety(params, czyUkrycAnulowane = this.state.ukryjAnulowane) {
        let idTr = null;
        if (Boolean(params.trasa)) {
            idTr = params.trasa.idTr
        }
        BiletyService.szukajBiletow(
            DateAndTimeUtilities.formatYYYYMMDD(params.dataOd),
            DateAndTimeUtilities.formatYYYYMMDD(params.dataDo),
            idTr,
            params.godz,
            params.czyDataSprzedazy,
            !czyUkrycAnulowane
        ).then(function (response) {

            let bilety = Array.from(response.data, item => {
                let kod = item.idBi
                if (Boolean(item.idBiPow)) {
                    kod += " " + item.idBiPow
                } else {
                    let zero = ''
                    for (let i = 0; i < item.idBi.length; i++) {
                        zero += '0'
                    }
                    kod += ' ' + zero
                }
                let platnosci = ''
                if (Boolean(item.platnosciTransakcja)) platnosci += item.platnosciTransakcja + ' '
                if (Boolean(item.platnoscTpay)) platnosci += item.platnoscTpay

                let statusinfo = "";

                if (item.statPoz === 2) {
                    statusinfo = 'skasowany'
                    if (item.skasowalKierowca) {
                        statusinfo += " " + item.skasowalKierowca
                    }
                }
                else if (item.statPoz === 1) {
                    statusinfo = "opłacony"
                }
                else if (item.statPoz === 0) {
                    statusinfo = "rezerwacja"
                }
                else if (item.statPoz === -1) {
                    statusinfo = "do opłaty"
                }
                else if (item.statPoz === -2) {
                    statusinfo = "anulowano klient"
                }
                else if (item.statPoz === -3) {
                    statusinfo = "anulowano operator"
                }
                else if (item.statPoz === -4) {
                    statusinfo = "zwrócony"
                }
                else if (item.statPoz === -5) {
                    statusinfo = "nieopłacony"
                }
                else if (item.statPoz === -6) {
                    statusinfo = "płatność zwrócona"
                }


                return {
                    ...item,
                    kodInfo: kod,
                    klientInfo: item.klient + ' ' + item.klientTelefon + ' ' + item.klientEmail + ' ' + item.nazKl + " " + item.sprzedazMiejsce,
                    infoPlatnosci: platnosci,
                    infoOdcinek: item.nazTr + ' ' + item.nazMiOd + ' ' + item.nazMiDo,
                    infoStatPoz: statusinfo,
                }
            })


            if (czyUkrycAnulowane) {
                // let arr = Array.from(bilety)
                // bilety = arr.filter(b=>b.statPoz !== -3 || b.statPoz !== '-3')
                this.refs.notificator.success('Ukryto bilety anulowane przez operatora', "", 3000)
            }

            this.setState({bilety: bilety})


        }.bind(this))
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    onClickSzukaj(params) {
        this.setState({params: params})
        this.pobierzBilety(params, this.state.ukryjAnulowane)
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc bilet o kodzie: ' + obj.idBi)) {
            BiletyService.deleteBilet(obj.idBi).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunieto bilet', "", 3000)
                    this.pobierzBilety(this.state.params, this.state.ukryjAnulowane)
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania biletu', "", 3000)
                }
            }.bind(this))
        }
    }

    onChangeStatus(status, obj) {
        BiletyService.editStatusWJednorazowym(obj.idBp, parseInt(status.value)).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono status biletu', "", 3000)
                this.pobierzBilety(this.state.params, this.state.ukryjAnulowane)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany statusu', "", 3000)
            }
        }.bind(this))
    }

    onChangeGodzina(idKu, obj) {
        BiletyService.editGodzinaWJednorazowym(obj.idBi, idKu).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono godzinę biletu', "", 3000)
                this.pobierzBilety(this.state.params, this.state.ukryjAnulowane)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany godziny', "", 3000)
            }
        }.bind(this))
    }

    onChangeKursNaBilecie = (idBi, idKu) => {

        BiletyService.editGodzinaWJednorazowym(idBi, idKu).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono kurs na bilecie '+idBi, "", 3000)
                this.pobierzBilety(this.state.params, this.state.ukryjAnulowane)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany kursu na bilecie', "", 3000)
            }
        }.bind(this))

    }

    onChangeIlosc(idBp, ile) {
        BiletyService.editIloscWJednorazowym(idBp, ile).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono ilość w bilecie', "", 3000)
                this.pobierzBilety(this.state.params, this.state.ukryjAnulowane)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany ilości', "", 3000)
            }
        }.bind(this))
    }

    onClickSzukajNumeruZParagonu() {
        this.setState({errorModal: ''})
        console.log(this.state.numerZParagonu)

        if (this.state.numerZParagonu.length === 0) {
            alert('Nie uzupełniono numeru z paragonu!')
        } else {
            this.setState({setLoader: true, pokazModal: true})

            BiletyService.szukajBiletuPoKodzieZParagonu(this.state.numerZParagonu.toString())
                .then(function (response) {
                    console.log(response)
                    this.setState({biletZSzukaniaPoKodzieZParagonu: response.data, setLoader: false})
                }.bind(this))
                .catch(function (err) {
                    this.setState({setLoader: false, errorModal: 'Nie znaleziono takiego kodu'})
                    setTimeout(function () {
                        this.setState({pokazModal: false})
                    }.bind(this), 2000)
                }.bind(this))
        }
    }


    onClickUkryjPokazAnulowane() {
        if (this.state.ukryjAnulowane) {
            // są ukryte -> pokazujemy
            this.setState({ukryjAnulowane: false})
            this.pobierzBilety(this.state.params, false)
        }
        else {
            // są pokazane -> ukrywamy
            this.setState({ukryjAnulowane: true})
            this.pobierzBilety(this.state.params, true)

        }
    }

    onClickPokazWiecejInformacji(idBi) {

        let bilet = 'R' + idBi

        this.setState({errorModal: ''})

        if (idBi.length === 0) {
            alert('Nie uzupełniono numeru z paragonu!')
        } else {
            this.setState({setLoader: true, pokazModal: true})

            BiletyService.szukajBiletuPoKodzieZParagonu(bilet.toString())
                .then(function (response) {
                    console.log(response)
                    this.setState({biletZSzukaniaPoKodzieZParagonu: response.data, setLoader: false})
                }.bind(this))
                .catch(function (err) {
                    this.setState({setLoader: false, errorModal: 'Nie znaleziono takiego kodu'})
                    setTimeout(function () {
                        this.setState({pokazModal: false})
                    }.bind(this), 2000)
                }.bind(this))
        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/bilety', text: 'Bilety jednorazowe'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <SzukajJednorazowychForm handleClickSzukaj={this.onClickSzukaj} trasy={this.state.trasy}
                                                     paramsObsady={this.state.paramsObsady}/>
                        </Col>
                        <Col xs={12}>
                            <div>
                                <div style={{lineHeight: '34px', float: 'left'}}>
                                    <ControlLabel>
                                        Wyszukaj po kodzie z paragonu:
                                    </ControlLabel>
                                </div>
                                <div style={{width: '266px', marginLeft: '8px', float: 'left'}}>
                                    <InputGroup>
                                        <FormControl type="text" onChange={(e) => {
                                            this.setState({numerZParagonu: e.target.value})
                                        }}
                                                     placeholder={'np: #000#00000#0'}/>
                                        <InputGroup.Button>
                                            <TopButtonAction text={'Szukaj'} btnColor={'warning'} iconType={'fa fa-search'} btnSize={'md'}
                                                             onClick={() => {
                                                                 this.onClickSzukajNumeruZParagonu()
                                                             }}
                                            />
                                        </InputGroup.Button>
                                    </InputGroup>
                                    <div data-tip='' data-for={"infoWyszukajPoKodzie"} data-place="right" className='tooltip_here'
                                         style={{display: "inline-block", cursor: "pointer", margin: 0, fontSize: "10px", color: "dodgerblue"}}>
                                        <i className={"fa fa-info-circle"}></i> Jak używać wyszukiwarki?
                                    </div>
                                    <ReactTooltip id={"infoWyszukajPoKodzie"}>
                                        <h5>Aby wyszukać bilet należy:</h5>
                                        <ul style={{margin: "5px", padding: 0}}>
                                            <li style={{marginTop: "5px"}}>
                                                <div style={{fontWeight: "bold"}}>podać jego kod (ID biletu) poprzedzony literą R</div>
                                                <div>
                                                    np.: R17000
                                                </div>
                                                <div>
                                                    <i className={"fa fa-exclamation-triangle"}></i> dotyczy się przypadków sprzedaży przez biuro,
                                                    stronę oraz aplikację
                                                </div>
                                            </li>
                                            <li style={{marginTop: "5px"}}>
                                                <div style={{fontWeight: "bold"}}>podać jego kod z paragonu</div>
                                                <div>
                                                    np.: #10#150000#1
                                                </div>
                                                <div style={{fontSize: "10px"}}>
                                                    gdzie:
                                                    <div>
                                                        pierwsza cyfra to ID kierowcy
                                                    </div>
                                                    <div>
                                                        druga cyfra to ID kursu
                                                    </div>
                                                    <div>
                                                        trzecia cyfra to nr wydruku
                                                    </div>
                                                </div>
                                                <div>
                                                    <i className={"fa fa-exclamation-triangle"}></i> dotyczy się biletów sprzedanych przez kierowcę
                                                </div>

                                            </li>
                                        </ul>
                                    </ReactTooltip>
                                </div>
                                <div style={{width: '400px', marginLeft: '60px', float: 'left'}}>
                                    <Checkbox onClick={() => this.onClickUkryjPokazAnulowane()} checked={this.state.ukryjAnulowane}>Ukryj bilety
                                        anulowane przez operatora</Checkbox>
                                </div>
                                <div style={{height: '1px', clear: 'both'}}></div>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <JednorazoweTable
                                data={this.state.bilety}
                                handleUsun={this.onClickUsun}
                                handleSelectStatus={this.onChangeStatus}
                                handleChangeGodzina={this.onChangeGodzina}
                                handleChangeIlosc={this.onChangeIlosc}
                                szukaneIdKursu={this.state.szukaneIdKursu}
                                wylaczIdKursuSzukanego={() => this.setState({szukaneIdKursu: null})}
                                handleClickPokazWiecejInformacji={(idBi) => this.onClickPokazWiecejInformacji(idBi)}
                                handleChangeKurs={this.onChangeKursNaBilecie}
                            />
                        </Col>
                    </Row>
                    {
                        this.state.pokazModal ?
                            <div id={'EBUSModalContainerBG'}>
                                <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                                    <div>
                                        <div id={'modalTextContent'}>
                                            <div>
                                                <div className={'pull-right'}>
                                                    <TopButtonAction onClick={() => {
                                                        this.setState({pokazModal: false, biletZSzukaniaPoKodzieZParagonu: null,})
                                                    }}
                                                                     elementStyle={{color: 'firebrick'}}
                                                                     btnColor={'default'} text={'Zamknij'}
                                                                     iconType={'fa fa-times'}
                                                    />

                                                </div>
                                            </div>
                                            <div style={{clear: 'both', height: '15px'}}></div>
                                            {
                                                this.state.setLoader ?
                                                    <div id={'simple-small-loader'}>
                                                        <i className={'fa fa-spinner fa-spin'}></i>
                                                    </div>
                                                    :
                                                    this.state.errorModal.length > 0 ?
                                                        <TopAlertUwaga text={this.state.errorModal}/>
                                                        :
                                                        <div>
                                                            <BiletKodZParagonuContainer bilet={this.state.biletZSzukaniaPoKodzieZParagonu}
                                                                                        zamknijModal={() => this.setState({
                                                                                            pokazModal: false,
                                                                                            biletZSzukaniaPoKodzieZParagonu: null
                                                                                        })}/>
                                                        </div>
                                            }

                                            <div style={{clear: 'both'}}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ''
                    }
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/BiletyJednorazoweContainer.js